import {
  BoxProps,
  Checkbox,
  CheckboxProps,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/react';
import React, { InputHTMLAttributes, useEffect, useState } from 'react';
import useTranslate from '~/common/utils/translate';
import { useField } from 'formik';

type SingleCheckboxSelectProps = BoxProps &
  InputHTMLAttributes<HTMLInputElement> &
  CheckboxProps & {
    name: string;
    label: string;
    row?: boolean;
    labelParams?: string[];
    errorParams?: string[];
    placeholderParams?: string[];
    onStateChange?: (value: boolean) => void;
  };

export const SingleCheckboxSelect: React.FC<SingleCheckboxSelectProps> = ({
  label,
  size: _,
  name,
  row = false,
  labelParams,
  errorParams,
  placeholderParams,
  onStateChange,
  ...props
}) => {
  const [field, { error }] = useField({ ...props, name });
  const [isChecked, setIsChecked] = useState(field.value as boolean);
  const translate = useTranslate();

  useEffect(() => {
    if (field.value !== isChecked) {
      onChangeLocal();
      setIsChecked(field.value);
    }
  }, [field]);

  const onChangeLocal = () => {
    if (onStateChange) onStateChange(field.value);
  };

  return (
    <FormControl isInvalid={!!error}>
      <Flex flexDirection={row ? 'row' : 'column'} align="center">
        <FormLabel htmlFor={field.name} mt={1}>
          {translate(label, labelParams)}
        </FormLabel>
        <Checkbox
          {...field}
          {...props}
          name={name}
          value={field.value}
          isChecked={field.value}
          borderColor="#807a7a"
        />
      </Flex>
      {error ? (
        <FormErrorMessage>{translate(error, errorParams)}</FormErrorMessage>
      ) : null}
    </FormControl>
  );
};
